import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby';
import { styled } from '../../styles/stitches.config';
import BackgroundImage from 'gatsby-background-image';

const HomePageHeaderSection = () => {

    const data = useStaticQuery(
        graphql`
          query {
            allFile: file(name: { eq: "homeimage2" }) {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1920) {
                    ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `
    )

    const imageData = data.allFile.childImageSharp.fluid;

    const Section = styled(BackgroundImage, {
        color: 'white',
        display: 'flex',
        flexFlow: 'column wrap',
        height: '100vh',
        maxHeight: '700px',
        fontFamily: '$default',
        padding: '100px 40px',
        alignItems: 'center',
        justifyContent: 'start',
        textAlign: 'center',
        '@bp1': {
            display: 'none',
        },
        '& h2': {
            fontSize: '60px',
            lineHeight: '1.2',
            '@bp1': {
                fontSize: '48px',
                lineHeight: '1.2',
            },
        },
        '& p': {
            fontSize: '24px',
            '@bp1': {
                // marginTop: '20px',
                fontSize: '22px',
                lineHeight: '1.2',
            },
        },
        '& a': {
            display: 'inline-block',
            marginTop: '24px',
            padding: '14px 40px',
            letterSpacing: '4px',
            fontFamily: '$lato',
            fontSize: '14px',
            textTransform: 'uppercase',
            backgroundColor: 'black',
            height: '48px',
        },
        '& .heroContainer': {
            paddingTop: '100px',
            display: 'grid',
            gridTemplateColumns: '3fr 4fr',
            textAlign: 'left',
            width: '100%',
            h2: {
                fontSize: '32px',
            },
            p: {
                fontFamily: '$lato',
                fontSize: '18px',
                lineHeight: '25px',
            },
            '@bp1': {
                gridTemplateColumns: '1fr',
                textAlign: 'center',
                color: 'black',
                a: {
                    color: 'white',
                }
            }
        },
    });

    return (
        <Section fluid={imageData}>
            <h2>Better Days Are Here</h2>
            <p>Gentle skincare, transformative results.</p>
            <div className="heroContainer">
                <div>
                </div>
                <div>
                    <h2>Multi-Active<br />Treatment Essence</h2>
                    <p>Formulated to care for skin’s natural integrity.<br />7 skin-correcting benefits in one gentle step.</p>
                    <Link to="/products/multi-active-treatment-essence">Shop Now</Link>
                </div>
            </div>
        </Section>
    )
}

export default HomePageHeaderSection
